import { render } from "./DeliveryTimeModal.vue?vue&type=template&id=0304a4a4&scoped=true"
import script from "./DeliveryTimeModal.vue?vue&type=script&lang=js"
export * from "./DeliveryTimeModal.vue?vue&type=script&lang=js"

import "./DeliveryTimeModal.vue?vue&type=style&index=0&id=0304a4a4&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0304a4a4"]])

export default __exports__